/** @module SiteAdmin/HomePage/NewController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/def",
	"csi/html/ViewRef",
	"csi/sessionConstants",
	"csi/xml",
	"./util"
], function(declare,_,ActionView,Controller,def,ViewRef, sessionConstants,xml,HomePageUtil) {

	return declare(Controller, {
		/**
		 * Return ActionView for form if view for selected productivity item is not hard-coded in HomePage view.
		 * @return {ActionView}
		 */
		getActionView: function() {
			var view = this.widget;
			if (view.getHomeViewRef({view: this.actionValue})) {
				return null;
			}

			var	defType = def.typeDefinition(view.defView.getTypeNode());
			var	defView = defType.getViewDef(view.defView.getId() + this.actionValue + "Form");
			return new ActionView(this, defView, view.getViewNode());
		},

		/**
		 * Add new pane to home page, whether hard-coded or configured in form.
		 */
		process: function() {
			var self = this;
			var fd = this.m_formData;
			var paneParams = {view: this.actionValue};
			var vr = this.widget.getHomeViewRef(paneParams);

			if (!vr) {
				var contextType = fd.getFieldValue("DashboardPaneContextType");
				var context = fd.getFieldValue("DashboardPaneContext");
				var domain = fd.getFieldValue("DashboardPaneDomain") || "";

				paneParams.contextType = contextType;
				paneParams.title = fd.getFieldValue("DashboardPaneTitle");
				paneParams.view =  fd.getFieldValue("DashboardPane");

				if (xml.isValidURL(context)) {
					paneParams.contextUrl = context;
				} else if (HomePageUtil.CONTEXT_TYPE_NAMES.includes(contextType)) {
					paneParams.contextName = context;
				} else if (context) {
					paneParams.contextState = context;
				}

				if (sessionConstants.isLocalUser) {
					// supplier portal views only make sense when both view and domain are specified; sometimes this is called when adding a
					// new pane and the domain is not yet known - in that case return null (force form to popup)
					vr = _.extend(new ViewRef(), {
						m_id: paneParams.view + domain
					});
				} else {
					vr = this.widget.getHomeViewRef(paneParams);
				}
			}

			// first, make sure context node is in cache
			this.when(this.m_cache.getNodeDeferred(paneParams.contextUrl), function(node) {
				// then add new pane to view
				self.when(self.widget._preActionNew(self, paneParams, vr), function() {
					// finally, continue with controller to save new layout
					Controller.prototype.process.call(self);
				});
			});
		}
	});
});
